// extracted by mini-css-extract-plugin
module.exports = {"root":"bg_bx","input":"bg_cv","label-col":"bg_dV","labelCol":"bg_dV","label":"bg_b7","sublabel":"bg_dW","actions":"bg_dX","button":"bg_cp","plus-btn":"bg_dY","plusBtn":"bg_dY"};